import React, { useState } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

import "./GeneralNavbar.css";

const navLinks = [
	{ to: "/", name: "Home" },
	{ to: "/members", name: "Members" },
	{ to: "/projects", name: "Projects" },
	{ to: "/publications", name: "Publications" },
	{ to: "/contact", name: "Contact" },
];

const GeneralNavbar = () => {
	const [isToggled, setIsToggled] = useState(false);

	const handleToggle = () => setIsToggled(!isToggled);

	return (
		<Navbar expand="lg" className="justify-content-between custom-navbar">
			<Navbar.Brand href="/" className="navbar-brand">
				Seo Lab
			</Navbar.Brand>
			<Navbar.Toggle
				aria-controls="basic-navbar-nav"
				className={`custom-toggler ${isToggled ? "custom-x" : ""}`}
				onClick={handleToggle}
			>
				<span className="bar1"></span>
				<span className="bar2"></span>
				<span className="bar3"></span>
			</Navbar.Toggle>
			<Navbar.Collapse id="basic-navbar-nav">
				<Nav className="justify-content-end general-nav">
					{navLinks.map((link) => (
						<Nav.Link
							as={Link}
							to={link.to}
							key={link.to}
							className="custom-link"
						>
							{link.name}
						</Nav.Link>
					))}
				</Nav>
			</Navbar.Collapse>
		</Navbar>
	);
};

export default GeneralNavbar;
